export const clearBiofuelSession = () => {
  sessionStorage.removeItem("biofuelCompositionData");
  sessionStorage.removeItem("biofuelBlendInfoData");
};